/* @flow */
import type {FetchAction} from './event';

type State = {+loading: boolean, +bundles: Object}

export type Action = FetchAction;

let initialState = { loading: true, bundles: {} };
export function bundles(state: State = initialState, action:Action): State {
    if(action.type === "FETCH_EVENT" || action.type === "REFRESH_EVENT") {
        let newState = {...state};
        let bundles = {};

        for (const eventId in action.data.attributes.events) {
            let eventBundles = action.data.attributes.events[eventId].bundles;
            for(let i = 0; i < eventBundles.length; i++) {
                bundles[eventBundles[i].id] = eventBundles[i];
            }
        }

        newState.loading = false;
        newState.bundles = bundles;

        return newState;
    } else if(action.type === "SET_BUNDLES") {
        let bundles = {};

        for(let i = 0; i < action.data.length; i++) {
            bundles[action.data[i].id] = action.data[i];
        }

        return {...state, loading: false, bundles: {...bundles}};
    }  else {
        return state;
    }
}
